import React, { useState } from 'react';
import { FormFooterButton, InputCss } from '../../../helper/CommonFunction';
import { ApiHandler } from '../../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../../components/ModalComponets';
import { UploadImage } from '../../../helper/UploadFile';

const AddCategories = ({ isOpen, onClose, setResetSearch, title }) => {
    const token = useSelector(state => state.user.userToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialState = {
        category_name: '',
    };

    const [formData, setFormData] = useState(initialState);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [profile_image, setProfile_image] = useState("");


    const { category_name } = formData;

    // Handle text input changes
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle Image Selection & Upload
    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setProfile_image(imageUrl);
            setUploadedImage(file); // Store file for API upload
        }
    };

    // Handle Modal Close
    const handleClose = () => {
        setFormData(initialState);
        setProfile_image("");
        setUploadedImage(null);
        onClose();
    };

    // Handle Form Submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        let uploadedImageUrl = null;

        // Ensure image is uploaded
        if (!uploadedImage) {
            toast.error('Please upload an image before submitting');
            return;
        }

        if (uploadedImage) {
            const uploadResponse = await UploadImage(uploadedImage, token, navigate);
            setProfile_image(`https://tezbikes.com/tezbike/assets/${uploadResponse}`);
            uploadedImageUrl = uploadResponse;
        }

        const body = {
            category_name: category_name,
            category_image: uploadedImageUrl,
        };

        try {
            const result = await ApiHandler('/add_category.php', 'POST', body, token, dispatch, navigate);
            if (result.data.status === "1") {
                toast.success(result?.data.msg);
                handleClose();
                setResetSearch(true);
            } else {
                toast.error(result?.data.msg);
            }
        } catch (error) {
            toast.error('Error submitting form');
        }
    };

    return (
        <ModalLarge isOpen={isOpen} title={title} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className='grid grid-cols-1  gap-y-4'>
                    {/* Category Name */}
                    <div>
                        <label htmlFor="category_name" className="block text-[#222] font-semibold mb-1">
                            Category Name
                        </label>
                        <input
                            type="text"
                            name="category_name"
                            value={category_name}
                            placeholder='Enter category name'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>

                    {/* Category Image Upload */}
                    <div>
                        <label htmlFor="category_image" className="block text-[#222] font-semibold mb-1">
                            Category Image (Required)
                        </label>
                        {profile_image && (
                            <div className="mt-2">
                                <img src={profile_image} alt="Preview" className="w-28 h-28 rounded-md border object-contain" />
                            </div>
                        )}
                        <input
                            type="file"
                            name="category_image"
                            accept="image/*"
                            onChange={handleImageUpload}
                            required
                            className="border rounded-md p-2 w-full"
                        />
                    </div>
                </div>

                {/* Submit Button */}
                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    );
};

export default AddCategories;
